var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/project/1"}},[_c('a-icon',{attrs:{"type":"safety"}}),_vm._v(" 关于我们 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }